import { render, staticRenderFns } from "./HelpCenterWrapper.vue?vue&type=template&id=0e580384&scoped=true"
import script from "./HelpCenterWrapper.vue?vue&type=script&lang=js"
export * from "./HelpCenterWrapper.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterWrapper.vue?vue&type=style&index=0&id=0e580384&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e580384",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/skade-pwa/components/ui/atom/Icon.vue').default,HelpLink: require('/skade-pwa/components/ui/atom/HelpLink.vue').default,Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
